import Home from "../pages/Home";
import Projects from "../pages/Projects";
import Skills from "../pages/Skills";
import Contact from "../pages/Contact";
import EmailIcon from "@mui/icons-material/Email";
import HomeIcon from "@mui/icons-material/Home";
import FolderIcon from "@mui/icons-material/Folder";
import CodeIcon from "@mui/icons-material/Code";
export const routesGen = {
  home: "/",
  reviewList: "/reviews",
};

const routes = [
  {
    index: true,
    element: <Home />,
    state: "home",
    color: "#FFFF00",
    path: "/",
    icon: <HomeIcon />,
  },
  {
    index: true,
    element: <Skills />,
    state: "skills",
    color: "#00FF00",
    path: "/skills",
    icon: <CodeIcon />,
  },
  {
    index: true,
    element: <Contact />,
    state: "Contact",
    color: "#FF0000",
    path: "/contact",
    icon: <EmailIcon />,
  },
  {
    index: true,
    element: <Projects />,
    state: "projects",
    color: "#0000FF",
    path: "/projects",
    icon: <FolderIcon />,
  },
];

export default routes;
